import Cookies from "js-cookie";
import { cookieConstants, authConstants } from "../_redux/_constants";
//TODO:Implement after login auth implementaion

export const setCsrfToken = (token) => {
  Cookies.set("XSRF-TOKEN", token);
};

export const getCsrfToken = () => {
  return Cookies.get("XSRF-TOKEN");
};

/**
 * Session is valid only in the same tab. New tab = no sessionStorage = not logged in.
 * So closing the tab and opening the URL in a new tab redirects to login.
 */
export const setSessionActive = () => {
  try {
    sessionStorage.setItem(authConstants.SESSION_ACTIVE, "true");
  } catch (e) {
    // ignore when sessionStorage is unavailable
  }
};

export const clearSessionActive = () => {
  try {
    sessionStorage.removeItem(authConstants.SESSION_ACTIVE);
  } catch (e) {
    // ignore
  }
};

/**
 * Soft SPA login check only: JS-readable `user` cookie + tab-scoped sessionStorage.
 * Does not validate auth-token (httpOnly). BFF JWT / API 401 is the source of truth.
 */
export const isUserLoggin = () => {
  const hasUserCookie = Cookies.get(cookieConstants.USER_DETAILS_COOKIE);
  const hasSession = sessionStorage.getItem(authConstants.SESSION_ACTIVE) === "true";
  if (typeof hasUserCookie != "undefined" && hasSession) {
    return true;
  }
  return false;
};

// Check login only by cookie, without relying on sessionStorage
export const isUserLogginByCookie = () => {
  const hasUserCookie = Cookies.get(cookieConstants.USER_DETAILS_COOKIE);
  return typeof hasUserCookie != "undefined";
};

export const getUserDetails = () => {
  const userDetails = Cookies.get(cookieConstants.USER_DETAILS_COOKIE);
  if (typeof userDetails != "undefined") {
    return JSON.parse(Cookies.get(cookieConstants.USER_DETAILS_COOKIE));
  }

  return {};
};

export const getIsAccountSync = () => {
  const isAccountSync = Cookies.get(cookieConstants.IS_ACCOUNTS_SYNC);

  if (typeof isAccountSync != "undefined") {
    return isAccountSync;
  }

  return "N";
};

export const getIdleTimeoutTime = (userDetails) => {
  const IdleTimeoutTime = userDetails?.userDetails?.sessionTimeoutIdleTime;

  if (typeof IdleTimeoutTime != "undefined") {
    return IdleTimeoutTime * 1000;
  }

  return parseInt(process.env.DEFAULT_IDLE_TIMEOUT_TIME);
};

export const removeUserDetails = () => {
  Cookies.remove(cookieConstants.USER_DETAILS_COOKIE);
  clearSessionActive();
};
